export const CLICK_TO_CHAT_FEATURE_FLAG = 'prebooking_click_to_chat';
